import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable, NgModule } from '@angular/core';
import { JsonResourceResponse } from 'app/generated/generated-common';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PartyPlaceDetailModel } from 'app/generated/backend/yard/api/party-place-detail-model';

@Injectable()
export class PartyPlaceDetailHandlerService {
	private handleError(error: Response | any) {
		return throwError(error);
	}
	constructor(private http: HttpClient) { }
	get(
		partyId: number,
		id: number
	): Observable<JsonResourceResponse<PartyPlaceDetailModel>> {
		return this.http.get<JsonResourceResponse<PartyPlaceDetailModel>>(`api/v1/yard/parties/${partyId}/places/detail/${id}`).pipe(
			map(response => response),
			catchError(this.handleError));
	}
	put(
		partyId: number,
		id: number,
		request: PartyPlaceDetailModel
	): Observable<JsonResourceResponse<PartyPlaceDetailModel>> {
		return this.http.put<JsonResourceResponse<PartyPlaceDetailModel>>(`api/v1/yard/parties/${partyId}/places/detail/${id}`, request).pipe(
			map(response => response),
			catchError(this.handleError));
	}
	delete(
		partyId: number,
		id: number
	): Observable<void> {
		return this.http.delete<void>(`api/v1/yard/parties/${partyId}/places/detail/${id}`).pipe(
			catchError(this.handleError));
	}
}

@NgModule({
	imports: [
		CommonModule
	],
	providers: [
		PartyPlaceDetailHandlerService
	]
})
export class PartyPlaceDetailHandlerModule { }
